<!-- LoadFormData -->

<template>
    <div>
        <span title="如果你之前填写过同一个表单, 点我可以加载上次填写的数据, 会覆盖(先清空)你现在已填写的数据"
            @click="showDialog">加载表单数据</span>

        <el-dialog
            top="7vh"
            title="加载表单数据"
            :modal="false"
            :visible.sync="dialogVisible"
            width="65%">
            <el-form
                inline
                style="margin-left:10px;">
                <el-form-item label="搜索工单">
                    <el-input v-model="searchKey" style="width:240px;" placeholder="输入工单编号或标题或内容搜索"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button title="查询符合条件的工单[19]"
                        style="width:80px;"
                        @click="doSearch">搜索</el-button>
                </el-form-item>
            </el-form>

            <el-table
                style="padding-left:10px;margin-bottom:30px;"
                :data="ticketList">
                <div slot="empty">
                    <div style="height:30px;">在上方的框中输入工单编号或标题，点击 <b>搜索</b></div>
                    <div>这里会列出你曾使用过的选项</div>
                    <div>向 <a target="_blank" href="/ticket/h">管理员</a> 寻求帮助</div>
                </div>

                <el-table-column property="orderId" label="编号" width="180px"></el-table-column>
                <el-table-column label="标题" min-width="250px">
                    <template slot-scope="scope">
                        <TicketTitle :ticketTitle="scope.row.orderTitle" :ticketNo="scope.row.orderId" />
                    </template>
                </el-table-column>

                <el-table-column property="creatorUser.name" label="创建人"></el-table-column>
                <el-table-column property="createdAt" label="创建时间"></el-table-column>

                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                    <a @click="doSelect(scope.row)">选择</a>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil';

export default {
    name : 'LoadFormData',

    data() {
        return {
            searchKey : '',
            ticketList : [],
            dialogVisible : false
        };
    },

    mounted() {
      this.loadPrevious();
    },

    methods : {
        doSelect(row) {
            var _this = this;

            sdk.TicketWorkflowApi().listFirstFormPropertyByTicketNo({
                ticketNo : row.orderId
            }).then( res => {
                if ( !res || !res.length || res.length < 1 ) {
                    console.log('#83 doSelect listFirstFormPropertyByTicketNo error, res=', res, 'row=', row);
                    _alert('加载表单内容失败 ' + JSON.stringify(res));
                    return;
                }

                var _properties = {};
                res.forEach(e => {
                    _properties[e.id] = _this.parsePropertyValue(e);
                });

                _this.$emit('selected', _properties);
                _this.dialogVisible = false;

                _this.addToPrevious(row.orderId);
            });
        },

        addToPrevious( _orderId ) {
            var _val = localStorage.getItem(CacheUtil.LoadFormDataIds) || "[]";
            var ids = JSON.parse( _val );
            if ( null == ids || ids.length < 1 ) {
                localStorage.setItem(CacheUtil.LoadFormDataIds, JSON.stringify( [ _orderId ] ) );
                return;
            }

            // 限制长度
            if ( ids.length > 10 ) {
                ids = ids.slice( ids.length - 10 );
            }

            // 保存
            ids.push(_orderId);
            this.loadByOrderId(this.arrayUnique(ids));
        },

        loadPrevious() {
            var _val = localStorage.getItem(CacheUtil.LoadFormDataIds) || "[]";
            var ids = JSON.parse( _val );
            if ( null == ids || ids.length < 1 ) {
                return;
            }

            this.loadByOrderId(ids);
        },

        loadByOrderId( orderIdList ) {
            var _this = this;

            var _filter =  { '$in' : { 'orderId' : orderIdList } };

            sdk.TicketApi().list({
                filter : _filter,
                page : { pageSize : 10 }
            }).then(res => {
                _this.ticketList = res.list;
            });
        },

        doSearch() {
            var _this = this;

            var _filter = {
                '$or' : [
                    { '$like' : { 'orderTitle' : '%' + _this.searchKey + '%' } },
                    { '$like' : { 'orderId' : '%' + _this.searchKey + '%' } }
                ]
            };

            sdk.TicketApi().list({
                filter : _filter,
                page : { pageSize : 10 }
            }).then(res => {
                _this.ticketList = res.list;
            });
        },

        showDialog() {
            this.dialogVisible = true;
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/LoadFormData.vue